import { FEATURES, CHECK_REQUIRED_FIELDS, WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { isFeatureVisible } from '../../capabilities/selector';
import type { WorkflowRule } from '../types';

// Standard mode: deal failed validation on a buyer or vehicle gap — show Deal Setup.
// Mirrors the INVALID rule in shared-bff-utils/showroomApplicationState.ts, so the status the
// server seeds at bootstrap matches what the client re-derives afterwards.
export const standardInvalidRule: WorkflowRule = (state: any): WorkflowStatus | null => {
    const { valid, missingFields = [] } = state?.salesCheckin?.dealValidation ?? {};
    const hasMissingFields = missingFields.some((field: string) =>
        CHECK_REQUIRED_FIELDS.some((section) => field.startsWith(section))
    );

    return isFeatureVisible(FEATURES.SALES_VIEW_REDIRECTION)(state ?? {}) && !valid && hasMissingFields
        ? WorkflowStatus.INVALID
        : null;
};
